import * as gemini from "gemini/gemini.web";
import {recordGif} from "../js/gifHelper";
import { drawVis } from "./util";
import React, { Component } from  'react';
import { Button, Spinner } from 'react-bootstrap'
import './css/AnimContainer.css'
import { debounce } from "vega";
import { objEqual } from '../js/util'

class AnimContainer extends Component {
  constructor(props){
    super(props);
    this.state = {
      status: "ready"
    }
    this.updateAnimViewWithDebounce = debounce(700, this.updateAnimView.bind(this));
  }


  render() {
    let sSpec = this.props.sSpec || {},
      eSpec = this.props.eSpec || {},
      gemSpec = this.props.gemSpec || {},
      sequence = this.props.sequence || [],
      animationSpecs = this.props.animationSpecs || []

    let buttonDescription = "Error!",
      controlBtnVariant="danger",
      controlBtnDisabled = true
    if (this.state.status === "ready") {
      buttonDescription = "Play";
      controlBtnVariant = "primary";
      controlBtnDisabled = false;
    } else if (["in progress", "recording"].indexOf(this.state.status) >= 0) {
      buttonDescription = "Playing...";
      controlBtnVariant = "primary";
      controlBtnDisabled = true;
    } else if (this.state.status === "done") {
      buttonDescription = "Reset";
      controlBtnVariant = "secondary";
      controlBtnDisabled = false;
    }

    if ((Object.keys(sSpec).length > 0) &&
        (
          ((Object.keys(gemSpec).length > 0) && (Object.keys(eSpec).length > 0)) ||
          ((Object.keys(animationSpecs).length > 0) && (Object.keys(sequence).length > 0))
        )
      ) {
      controlBtnDisabled = false;
    } else {
      controlBtnDisabled = true;
    }

    return <div className={this.props.className}>
      <div className="text-center" style={{height: this.props.height || 350}}>

        <Button
          variant={controlBtnVariant}
          size="sm"
          className="controlBtn"
          id={`${this.props.id}ControlBtn`}
          data-target-id={`${this.props.id}Anim`}
          onClick={this.onControlBtnClick.bind(this)}
          disabled={controlBtnDisabled}
        >
          { buttonDescription }
        </Button>{
          this.state.hasBuffer ? "*" : ""
        }
        {
          this.props.showGif ?
          <Button
            id={`${this.props.id}GifBtn`}
            size="sm"
            variant="light"
            data-target-id={`${this.props.id}Anim`}
            className="ml-1 controlBtn"
            onClick={this.onGifBtnClick.bind(this)}
            disabled={controlBtnDisabled || (this.state.status !== "ready")}
          >
            {this.gifBtnContent()}

          </Button> :
          ""
        }

        <br/>
        <div className="animContainer">
          <div id={`${this.props.id}Anim`} className="mt-3"></div>
          <div id={`${this.props.id}AnimBuffer`} className="mt-3 d-none"></div>
        </div>
      </div>


      {
        this.props.showMetaInfo ?

        <p className="card-text" style={{whiteSpace: "pre-line" }}>
          {
          `Complexity: ${this.props.meta.cost}
          Stage: ${this.props.meta.stageN}`
          }
        </p>
        : ""
      }
    </div>
  }
  gifBtnContent(){

    if (this.state.status === "recording") {
      return <div>
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
        <span className="sr-only">Loading...</span>
      </div>
    }
    return "🎥 GIF";
  }

  async componentDidUpdate(prevProps) {
    if ((!objEqual(prevProps.sSpec, this.props.sSpec))
      || (!objEqual(prevProps.eSpec, this.props.eSpec))
      || (!objEqual(prevProps.gemSpec, this.props.gemSpec))
      || (!objEqual(prevProps.sequence, this.props.sequence))
      || (!objEqual(prevProps.animationSpecs, this.props.animationSpecs))) {


      await this.updateAnimViewWithDebounce()
    }
  }
  async updateAnimView() {
    // When updating the vis while playing,
    if (this.state.status === "in progress") {
      await drawVis(`#${this.props.id}AnimBuffer`, this.props.sSpec);
      this.setState({hasBuffer: true});
    } else {
      this.setState({status: "ready"});
      await drawVis(`#${this.props.id}Anim`, this.props.sSpec);
    }
  }
  async componentDidMount(){
    this.setState({status: "ready"});
    await drawVis(`#${this.props.id}Anim`, this.props.sSpec);
  }

  async onGifBtnClick(event) {
    let targetElm = `#${event.target.dataset.targetId}`;

    // targetElm.setAttribute("disabled", true)
    await this.setState({status: "recording"});
    await this.play(
      targetElm,
      recordGif.bind(this),
      ((anim) => {
        if (this.props.onEnd) {
          this.props.onEnd(anim);
        }

        return true;
      })
    );


  }
  async onControlBtnClick(event) {
    let targetElm = `#${event.target.dataset.targetId}`;
    if (this.state.status === "ready") {
      // targetElm.setAttribute("disabled", true)
      this.setState({status: "in progress"});
      await this.play(
        targetElm,
        undefined,
        ((anim) => {
          if (this.props.onEnd) {
            this.props.onEnd(anim);
          }
          return true;
        })
      );

      // targetElm.removeAttribute("disabled");
      if (this.state.hasBuffer) {
        const animDivElm = document.getElementById(this.props.id+"Anim");
        const bufferDivElm = document.getElementById(this.props.id+"AnimBuffer");
        animDivElm.innerHTML = bufferDivElm.innerHTML;
        bufferDivElm.innerHTML = "";
        this.setState({hasBuffer: false, status: "ready"});
      } else {
        this.setState({status: "done"});
      }

    } else if (this.state.status === "done") {
      await this.reset(targetElm, this.props.sSpec);
      this.setState({status: "ready"});
    }
  }

  async play(targetElm, onStart, onEnd){
    let anim;
    if (this.props.sequence) {
      let sequence = this.props.sequence.map(chart => {
        if (chart && chart.$schema.indexOf("https://vega.github.io/schema/vega-lite") >= 0){
          return gemini.vl2vg4gemini(chart)
        }
        return chart
      })
      anim = await gemini.animateSequence(sequence, this.props.animationSpecs);
    } else {
      let startSpec = this.props.sSpec,
        endSpec = this.props.eSpec,
        gemSpec = this.props.gemSpec

      anim = await gemini.animate(startSpec, endSpec, gemSpec);
    }

    // await drawVis(targetElm, sSpec)
    console.log("Start!");
    if (onStart) {
      onStart(anim, {targetElm, ...this.props});
    }
    await anim.play(targetElm)
    console.log("Done!");
    if (onEnd) {
      onEnd(anim, {targetElm, ...this.props});
    }
    return true;
  }

  async reset(targetElm, sSpec){
    await drawVis( `${targetElm}`, sSpec);
  }

}

export default AnimContainer;


